if (!customElements.get('product-similar-carousel')) {
  customElements.define(
    'product-similar-carousel',
    class ProductSimilarCarousel extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-similar-list]');
        this.previousButton = this.querySelector('[data-similar-previous]');
        this.nextButton = this.querySelector('[data-similar-next]');

        if (!this.list || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
      }

      get step() {
        const item = this.list.querySelector('.product-similar__item');
        if (!item) return this.list.clientWidth;

        const styles = window.getComputedStyle(this.list);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      move(direction) {
        const maximumScroll = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
        const atStart = this.list.scrollLeft <= 2;
        const atEnd = this.list.scrollLeft >= maximumScroll - 2;

        if (direction < 0 && atStart) {
          this.list.scrollTo({ left: maximumScroll, behavior: 'smooth' });
          return;
        }

        if (direction > 0 && atEnd) {
          this.list.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }

        this.list.scrollBy({ left: direction * this.step, behavior: 'smooth' });
      }
    }
  );
}
